import Spline from '@splinetool/react-spline';

const ApsemUI = () => {
  return (
    <Spline className="aud-spline" scene="https://prod.spline.design/ZuNxFmesenXWeszQ/scene.splinecode" />
  );
}

export default ApsemUI;